import type { AxiosInstance } from 'axios';
import authService from './auth.service';

/**
 * The country switch: which countries the portal may do new business in. Super admin only.
 *
 *   GET  /api/v1/admin/jurisdictions                   every country, its switch and history
 *   POST /api/v1/admin/jurisdictions/{code}/on         one super admin, with a reason and a code
 *   POST /api/v1/admin/jurisdictions/{code}/off        one super admin, with a reason
 */
export interface SwitchEvent {
  /** 'requested' only in the history written before one person could switch a country on. */
  state: 'requested' | 'enabled' | 'disabled';
  reason: string;
  requested_by_name: string | null;
  confirmed_by_name: string | null;
  at: string;
}

export interface Country {
  code: string;
  name: string;
  enabled: boolean;
  history: SwitchEvent[];
}

class AdminJurisdictionsService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  private readonly base = '/api/v1/admin/jurisdictions';

  async list(): Promise<Country[]> {
    const res = await this.api.get<Country[]>(this.base);
    return res.data;
  }

  async on(code: string, reason: string, mfaCode: string): Promise<void> {
    await this.api.post(`${this.base}/${code}/on`, { reason, mfa_code: mfaCode });
  }

  async off(code: string, reason: string): Promise<void> {
    await this.api.post(`${this.base}/${code}/off`, { reason });
  }
}

export default new AdminJurisdictionsService();
